import React, { useEffect, useState } from "react";
import { Badge, Input, Label } from "reactstrap";
import { Trans } from "react-i18next";
import moment from "moment";
import { post } from "helpers/api_helper";
import { SHOW_ACTIVITY_LOGS } from "helpers/api_endpoints";
import Loader from "common/loader";
import { getAction, getUser } from "pages/Logs/logUtils";

// Audit entries for one order. The backend matches any url ending in /{id} or a
// request mentioning the id, so keep only order related urls here.
const OrderActivityLog = ({ orderId }) => {
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [hideViews, setHideViews] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    post(SHOW_ACTIVITY_LOGS, { type: "api/orders", action: "", id: orderId })
      .then(response => {
        setLogs((response.data || []).filter(el => el.url?.toLowerCase().includes("order")));
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setError(err.response?.data?.message || "Could not load activity log");
        setLoading(false);
      });
  }, [orderId]);

  if (loading) return <Loader />;
  if (error) return <p className="text-danger"><Trans>{error}</Trans></p>;

  const shown = hideViews
    ? logs.filter(el => !["show", "details"].includes(getAction(el.url)))
    : logs;

  return (
    <>
      <div className="form-check mb-3">
        <Input
          type="checkbox"
          className="form-check-input"
          id="hideViews"
          checked={hideViews}
          onChange={e => setHideViews(e.target.checked)}
        />
        <Label className="form-check-label" htmlFor="hideViews">
          <Trans>Hide view requests</Trans>
        </Label>
      </div>
      {shown.length == 0 ? (
        <p className="text-muted"><Trans>No activity found</Trans></p>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm table-striped table-bordered align-middle">
            <thead>
              <tr>
                <th><Trans>Date</Trans></th>
                <th><Trans>Action</Trans></th>
                <th><Trans>By</Trans></th>
                <th><Trans>Request</Trans></th>
              </tr>
            </thead>
            <tbody>
              {shown.map(el => (
                <tr key={el.id}>
                  <td className="text-nowrap">{moment(el.createdAt).format("YYYY-MM-DD HH:mm:ss")}</td>
                  <td>
                    <Badge className="bg-success">{getAction(el.url)}</Badge>
                    <div className="text-muted small">{el.url}</div>
                  </td>
                  <td><Badge className="bg-danger">{getUser(el.userInfo)}</Badge></td>
                  <td style={{ maxWidth: 420, wordBreak: "break-all" }} className="small">{el.request}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default OrderActivityLog;
